import styled from "styled-components";

export const Container = styled.article`
  padding: 14px;
  background-color: ${(props) => props.theme.colors.brand1.dark};
  border: 1px solid ${(props) => props.theme.colors.neutral1.pure};
  text-align: center;
  border-radius: 4px;
  margin: 20px auto;
  width: 95%;
  animation-name: init-animation;
  animation-duration: 0.5s;

  @media (min-width: 768px) {
    width: 60%;
  }

  @keyframes init-animation {
    0% { opacity: 0; transform:translateY(-50px); }
    100% { opacity: 1; transform:translateY(0);}
  }

  > h6 {
    font-size: 1rem;
    color: ${(props) => props.theme.colors.neutral1.pure};
    font-weight: normal;

    @media (min-width: 768px) {

        font-size: 0.89rem;
    }
  }
`;
